/**
 * edpuzzle — interactive video lessons, with screen recorder
 *
 * Declares one WAR group matched to every URL with no use_dynamic_url: a handful of
 * UI images plus the screen-recorder HTML/CSS shells and a countdown audio clip. The
 * vendor-named pinExtension.png image loads via <img> with no CORS grant, and the
 * screen-recorder pages corroborate from independent fixed URLs.
 *
 * Manifest verified against version 5.1.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'oligonmocnihangdjlloenpndnniikol';

export const edpuzzle: ExtensionDefinition = {
  id: ID,
  name: 'edpuzzle',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Static UI images and screen-recorder shells on every origin with no dynamic URL. ' +
    'The PNG image loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-pin-extension-png',
      kind: 'web-accessible-resource',
      description:
        'Load images/pinExtension.png via <img> — a vendor-named UI image exposed to ' +
        'every origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/pinExtension.png'),
    },
    {
      id: 'war-mic-blocked-jpg',
      kind: 'web-accessible-resource',
      description:
        'Load images/mic-blocked.jpg via <img> — a second static image, corroborating ' +
        'the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/mic-blocked.jpg'),
    },
    {
      id: 'war-webcam-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch screen_recorder/html/webcam.html — a screen-recorder shell on a stable ' +
        'path, independent of the image probes.',
      weight: 0.5,
      run: () => probeFetch(ID, 'screen_recorder/html/webcam.html'),
    },
  ],
};
